import React from 'react'
import { Helmet } from 'react-helmet'

const SeoHome = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href='https://gemvision.com' />
      <script type='application/ld+json'>
        {`{
            "@context": "http://schema.org",
            "@type": "Corporation",
            "foundingLocation": "United States",
            "foundingDate": "1990-01-01",
            "sameAs": [
                "https://twitter.com/GemvisionCorp",
                "https://www.facebook.com/GemvisionCorp/",
                "https://www.instagram.com/gemvisioncorp/",
                "https://www.linkedin.com/company/11521138/admin/",
                "https://www.youtube.com/gemvisioncorp"
            ],
            "address": "302 Rue Louis XIV, Lafayette, LA 70508, United States",
            "email": "info@gemvision.com",
            "url": "https://gemvision.com/",
            "location": "Lafayette, LA 70508, United States",
            "name": "Gemvision Corportation",
            "telephone": "+34 937 547 774",
            "subOrganization": "https://www.stuller.com/",
            "slogan": "Innovation is our Tradition",
            "brand": "Gemvision",
            "description": "With facilities in the United States and a global network of Authorized Dealers, Gemvision brings jewelers and technology together with innovative, award-winning CAD/CAM products. ",
            "additionalType": "https://www.stuller.com/",
            "image": "https://gemvision.com/Images/gemvision_logo.svg",
            "@id": "http://schemaapp.com/db/Genv#Corporation"
        }`}
      </script>
      <script type='application/ld+json'>
        {`{
          "@context": "http://schema.org",
          "@id": "https://gemvision.com/#website",
          "@type": "WebSite",
          "url": "https://gemvision.com",
          "name": "Gemvision",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://gemvision.com/search/{search_term_string}?src=mc_google",
            "query-input": "required name=search_term_string"
          }
	      }`}
      </script>
      <script type='application/ld+json'>
        {`{
          "@context": "http://schema.org",
          "@id": "https://gemvision.com/#webpage",
          "@type": "WebPage",
          "url": "https://gemvision.com/",
          "name": "Gemvision"
	      }`}
      </script>
    </Helmet>
  )
}

export default SeoHome
